import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-page-size-selector',
  templateUrl: './page-size-selector.component.html',
  styleUrls: ['./page-size-selector.component.css']
})
export class PageSizeSelectorComponent {
  @Input() pageSize: number = 15;
  @Input() pageSizeOptions: number[] = [15, 25, 50, 100];
  @Input() label: string = 'Mostrar';
  @Input() suffix: string = 'registros';
  @Input() disabled: boolean = false;
  
  @Output() pageSizeChange = new EventEmitter<number>();

  onPageSizeChange(event: any) {
    const newSize = parseInt(event.target.value);
    this.pageSize = newSize;
    this.pageSizeChange.emit(newSize);
  }
}
